import { css, setProps, styled } from "theme";

interface SFilterSelectClearProps {
  isArabic: boolean;
}

const isArabicLang = setProps<SFilterSelectClearProps>(({ isArabic }) => isArabic)(css`
  left: 4px;
`);

const isNotArabicLang = setProps<SFilterSelectClearProps>(({ isArabic }) => !isArabic)(css`
  right: 4px;
`);

export const SFilterSelectClear = styled.button<SFilterSelectClearProps>`
  position: absolute;
  top: 50%;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);
  ${isNotArabicLang};
  ${isArabicLang};
`;
